import React, { useLayoutEffect } from 'react';
import { useAsyncValue, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// Components Styled
import { Container } from './styles';

// Types and Const
import NewWorkOrderForm from '../../../../../components/forms/NewWorkOrderForm';
import { formAccidentNaming } from '../../../../../components/forms/AddBasicInfoAccidentForm/constants';
import { WorkOrderEditAccident } from './types';
import { WorkOrder } from '../../../../../types/workOrder';

// Store
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';

export default function EditAccidentWorkOrderPage(): JSX.Element {
  const { t } = useTranslation();
  const loaderData = useAsyncValue() as WorkOrderEditAccident;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    //if (!loaderData) navigate('/work-orders/accidents');
    if (loaderData.orderId) {
      dispatch(
        roidOTSelected('edit-accident', loaderData.roid, loaderData.orderId)
      );
    }
  }, [loaderData]);

  const onFormSubmit: SubmitHandler<WorkOrder> = async () => {
    navigate('basic-info');
  };

  return (
    <Container>
      <NewWorkOrderForm
        initialData={loaderData}
        onFormSubmit={onFormSubmit}
        namingPersistForm={formAccidentNaming.EDIT_ACCIDENT_FORM}
        titleBasicInfo={t('common:workOrder.basicInfoAccident')}
        titleDate={t('common:workOrder.accidentDate')}
        textDateHour={t('common:workOrder.accidentTime')}
        isAccident={true}
        // "Registrado por" obligatorio también al EDITAR (decisión usuario
        // 2026-08-05). Faltaba el flag: el campo se pintaba pero el schema lo
        // dejaba opcional, así que se podía continuar sin él — mientras que
        // editar una ACTUACIÓN sí lo exige (`ActionEdition/schema.ts`, misma
        // decisión tomada el 2026-07-24). Era asimetría, no diseño.
        registeredByRequired
        // Sin pre-relleno en edición (decisión del usuario 2026-08-05): si el
        // accidente no trae operario, el campo sale VACÍO y hay que elegirlo.
        // Con el pre-relleno puesto, el obligatorio de arriba no llegaba a
        // morder nunca — el hueco se tapaba con quien estuviera editando.
        prefillRegisteredBy={false}
      />
    </Container>
  );
}
